<template>
    <div class="h-full">
        <TransitionRoot v-if="!is_guest" as="template" :show="sidebarOpen">
            <Dialog class="relative z-50 lg:hidden" @close="sidebarOpen = false">
                <TransitionChild as="template" enter="transition-opacity ease-linear duration-300"
                    enter-from="opacity-0" enter-to="opacity-100" leave="transition-opacity ease-linear duration-300"
                    leave-from="opacity-100" leave-to="opacity-0">
                    <div class="fixed inset-0 bg-gray-900/80" />
                </TransitionChild>

                <div class="fixed inset-0 flex">
                    <TransitionChild as="template" enter="transition ease-in-out duration-300 transform"
                        enter-from="-translate-x-full" enter-to="translate-x-0"
                        leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0"
                        leave-to="-translate-x-full">
                        <DialogPanel class="relative mr-16 flex w-full max-w-xs flex-1">
                            <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0"
                                enter-to="opacity-100" leave="ease-in-out duration-300" leave-from="opacity-100"
                                leave-to="opacity-0">
                                <div class="absolute left-full top-0 flex w-16 justify-center pt-5">
                                    <button type="button" class="-m-2.5 p-2.5" @click="sidebarOpen = false">
                                        <span class="sr-only">Close sidebar</span>
                                        <XMarkIcon class="size-6 text-white" aria-hidden="true" />
                                    </button>
                                </div>
                            </TransitionChild>
                            <!-- Sidebar component, swap this element with another sidebar if you like -->
                            <div
                                class="flex grow flex-col gap-y-7 overflow-y-auto bg-gray-900 px-6 pb-4 ring-1 ring-white/10">
                                <div class="flex h-16 shrink-0 items-center">
                                    <inertia-link :href="route('library.personal')">
                                        <img v-if="$page.props.app_env == 'staging'" class="h-8 w-auto"
                                            src="/img/birdie-logo-staging.png" alt="logo" />
                                        <img v-else class="h-8 w-auto" src="/img/birdie-logo.svg" alt="logo" />
                                    </inertia-link>
                                </div>
                                <nav class="flex flex-1 flex-col">
                                    <ul role="list" class="flex flex-1 flex-col gap-y-3">
                                        <li>
                                            <ul role="list" class="-mx-2 space-y-1 ">
                                                <li class="mb-4 hidden md:block">
                                                    <button type="button" @click="sidebarOpen = true"
                                                        class="rounded-md border-blue-gradient hover:border-blue-gradient-hover border px-3 py-2 text-sm font-semibold text-gray-100 shadow-sm  focus-visible:outline-none text-left flex w-full items-center gap-x-3">
                                                        <VideoCameraIcon class="size-5 shrink-0" aria-hidden="true" />
                                                        Record my Screen
                                                    </button>
                                                </li>
                                                <li>
                                                    <button type="button" @click="sidebarOpen = true"
                                                        class="rounded-md border-blue-gradient hover:border-blue-gradient-hover border px-3 py-2 text-sm font-semibold text-gray-100 shadow-sm  focus-visible:outline-none text-left flex w-full items-center gap-x-3">
                                                        <LinkIcon class="size-5 shrink-0" aria-hidden="true" /> Request
                                                        a recording
                                                    </button>
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            <div class="text-xs/6 font-semibold text-gray-400 mb-0">Library</div>
                                        </li>
                                        <li>
                                            <ul role="list" class="-mx-2 space-y-1">
                                                <li>
                                                    <inertia-link :href="route('library.incoming')"
                                                        :class="[is_route_incoming ? 'bg-white text-gray-800' : 'text-gray-400 hover:bg-gray-800 hover:text-white', 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold']">
                                                        <InboxArrowDownIcon class="size-5 shrink-0"
                                                            aria-hidden="true" />
                                                        Incoming Recordings
                                                    </inertia-link>
                                                </li>
                                                <li>
                                                    <inertia-link :href="route('library.team')"
                                                        :class="[is_route_team ? 'bg-white text-gray-800' : 'text-gray-400 hover:bg-gray-800 hover:text-white', 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold']">
                                                        <UserGroupIcon class="size-5 shrink-0" aria-hidden="true" />
                                                        Team
                                                    </inertia-link>
                                                </li>
                                                <li>
                                                    <inertia-link :href="route('library.personal')"
                                                        :class="[is_route_personal ? 'bg-white text-gray-800' : 'text-gray-400 hover:bg-gray-800 hover:text-white', 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold']">
                                                        <UserIcon class="size-5 shrink-0" aria-hidden="true" />
                                                        Personal
                                                    </inertia-link>
                                                </li>
                                            </ul>

                                            <div v-if="unified_personals_enabled" v-show="!sidebarCollapsed"
                                                class="text-xs/6 font-semibold text-gray-400 mb-2 mt-5">Admin View
                                            </div>
                                            <ul v-if="unified_personals_enabled" role="list" class="-mx-2 space-y-1">
                                                <li
                                                    :class="[sidebarCollapsed ? 'flex justify-center items-center' : '']">
                                                    <inertia-link :href="route('library.unified_personals')"
                                                        :class="[is_route_admin_view ? 'bg-white text-gray-800' : 'text-gray-400 hover:bg-gray-800 hover:text-white',
                                                        sidebarCollapsed ? 'size-10 justify-center' : 'justify-between',
                                                            'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold items-center ']"
                                                        v-tippy="{ content: sidebarCollapsed ? 'Unified Personals' : null, placement: 'right' }">
                                                        <UsersIcon
                                                            :class="[sidebarCollapsed ? 'size-4' : 'size-5', 'shrink-0']"
                                                            aria-hidden="true" />
                                                        <span v-if="!sidebarCollapsed"
                                                            class="whitespace-nowrap flex-1">Unified Personals</span>

                                                    </inertia-link>

                                                </li>
                                            </ul>

                                        </li>
                                        <li v-if="false">
                                            <div class="text-xs/6 font-semibold text-gray-400">Your teams</div>
                                            <ul role="list" class="-mx-2 mt-2 space-y-1">
                                                <li v-for="team in teams" :key="team.name">
                                                    <a :href="team.href"
                                                        :class="[team.current ? 'bg-gray-800 text-white' : 'text-gray-400 hover:bg-gray-800 hover:text-white', 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold']">
                                                        <span
                                                            class="flex size-6 shrink-0 items-center justify-center rounded-lg border border-gray-700 bg-gray-800 text-[0.625rem] font-medium text-gray-400 group-hover:text-white">{{
                                                                team.initial }}</span>
                                                        <span class="truncate">{{ team.name }}</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>

                                        <li class="mt-auto flex flex-col gap-y-4">

                                            <inertia-link v-if="false" type="button" :href="route('settings.helpdesk')"
                                                class="rounded-md bg-transparent -ml-3 px-3 py-0 text-sm font-normal text-gray-300 hover:text-gray-200 focus-visible:outline-none text-center flex justify-center items-center gap-x-3 hover:scale-105 transition-all duration-300 group">
                                                <img src="/img/waving-hand.png" alt="wave"
                                                    class="rotate-[20deg] size-5 group-hover:-rotate-[20deg] transition-all duration-300" />
                                                Refer your friends</inertia-link>

                                            <div class="h-px bg-gray-700 -mx-2"></div>

                                            <inertia-link type="button"
                                                v-if="$page.props.canManageSettings && !$page.props.has_integrations"
                                                :href="route('settings.helpdesk')"
                                                class="rounded-md bg-birdie-green -mx-2 px-3 py-2 text-sm font-semibold text-birdie-dark shadow-sm hover:bg-birdie-green-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-birdie-green-dark text-left">Connect
                                                Helpdesk</inertia-link>


                                            <inertia-link :href="settingsLandingPage"
                                                :class="[route().current('settings.*') || route().current('profile.index') || route().current('teams.*') || route().current('subscription.*') ? 'bg-white text-gray-800' : 'text-gray-400 hover:bg-gray-800 hover:text-white', 'group -mx-2 flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold']">
                                                <Cog8ToothIcon class="size-6 shrink-0" aria-hidden="true" />
                                                Settings
                                            </inertia-link>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </Dialog>
        </TransitionRoot>

        <!-- Static sidebar for desktop -->
        <div v-if="!is_guest"
            :class="[sidebarCollapsed ? 'lg:w-16' : 'lg:w-72', 'hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:flex-col transition-[width] duration-300 ease-in-out']">
            <!-- Sidebar component, swap this element with another sidebar if you like -->
            <div class="flex grow flex-col gap-y-7 overflow-y-auto bg-gray-900  pb-4"
                :class="[sidebarCollapsed ? 'px-2' : 'px-6']">

                <div class="flex shrink-0 items-center justify-between"
                    :class="[sidebarCollapsed ? 'flex-col gap-y-2' : 'h-16']">

                    <inertia-link v-if="!sidebarCollapsed" :href="route('library.personal')">
                        <img v-if="$page.props.app_env == 'staging'" class="h-8 w-auto"
                            src="/img/birdie-logo-staging.png" alt="logo" />
                        <img v-else class="h-8 w-auto" src="/img/birdie-logo.svg" alt="logo" />
                    </inertia-link>

                    <div v-else
                        class="flex justify-center items-center size-10 mt-4 text-sm font-normal transition-all duration-200 rounded-md text-gray-400  hover:bg-gray-800 cursor-pointer"
                        @click="expandSidebar" v-tippy="{ content: 'Expand', placement: 'right' }">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                            fill="currentColor">
                            <path
                                d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm200-80h360v-560H400v560Z" />
                        </svg>
                    </div>

                    <div v-if="$page.props.canManageSettings" class="flex-grow flex items-center justify-end">
                        <inertia-link :href="route('teams.show', $page.props.user.current_team) + '#invite'"
                            class="flex items-center gap-x-0.5 text-sm font-normal transition-all duration-200 rounded-md hover:bg-gray-800"
                            :class="[sidebarCollapsed ? 'p-1 size-10 justify-center' : 'flex-block py-1 pr-1 pl-2']"
                            v-tippy="{ content: sidebarCollapsed ? 'Invite your team' : null, placement: 'right' }">
                            <span class="text-birdie-aqua whitespace-nowrap" v-if="!sidebarCollapsed">Invite your
                                team</span>
                            <PlusIcon v-if="!sidebarCollapsed" class="size-4 text-birdie-aqua" />
                            <UserPlusIcon v-else class="size-5 text-birdie-aqua" />
                        </inertia-link>
                    </div>

                    <div v-if="!sidebarCollapsed" class="w-6 ml-3 -mr-6 flex items-center justify-end">
                        <div class="w-5 h-10 flex items-center justify-end text-gray-500 hover:bg-gray-700 bg-gray-800 hover:text-gray-400 hover:w-6 rounded-l-md cursor-pointer group transition-all duration-200"
                            v-tippy="{ content: 'Collapse Menu', placement: 'right', delay: [1000, 0] }"
                            @click="collapseSidebar">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                class="absolute w-6 h-6 translate-x-1 group-hover:translate-x-0 transition-all duration-200"
                                viewBox="0 -960 960 960" fill="currentColor">
                                <path d="M565.5-266.85 352.35-480 565.5-693.15v426.3Z" />
                            </svg>
                        </div>
                    </div>

                </div>

                <nav class="flex flex-1 flex-col">
                    <ul role="list" class="flex flex-1 flex-col gap-y-7">

                        <li>
                            <ul role="list" class="-mx-2 space-y-1 ">
                                <li class="mb-4 flex justify-center">
                                    <button v-if="is_chrome && extension_not_loaded_for_sure" type="button"
                                        @click="openInternalRecorder()"
                                        class="rounded-md bg-gray-50 border-transparent hover:bg-gray-200  border  text-sm font-semibold text-birdie-dark shadow-sm focus-visible:outline-none  flex items-center gap-x-3 overflow-hidden"
                                        :class="[sidebarCollapsed ? 'p-1 size-10 justify-center' : 'flex-block px-3 py-2 w-full text-left']"
                                        v-tippy="{ content: sidebarCollapsed ? 'Install free extension' : null, placement: 'right' }">
                                        <span :class="[sidebarCollapsed ? 'size-4' : 'size-5']">
                                            <svg id="baseSvg" xmlns="http://www.w3.org/2000/svg"
                                                preserveAspectRatio="xMidYMid meet" focusable="false"
                                                style="pointer-events: none; display: block; width: 100%; height: 100%;"
                                                viewBox="0 -960 960 960" fill="currentColor">
                                                <g viewBox="0 -960 960 960">
                                                    <path
                                                        d="M216-135.869q-33.287 0-56.709-23.422-23.422-23.422-23.422-56.709v-172.304q37.609-2 63.218-28.424 25.608-26.424 25.608-63.272t-25.608-63.272q-25.609-26.424-63.218-28.424V-744q0-33.287 23.422-56.709 23.422-23.422 56.709-23.422h161.065q2.631-40.956 31.96-69.315 29.329-28.359 70.75-28.359t70.975 28.199q29.554 28.199 32.185 69.475H744q33.287 0 56.709 23.422 23.422 23.422 23.422 56.709v161.065q40.956 2.631 69.315 31.96 28.359 29.329 28.359 70.75t-28.199 70.975q-28.199 29.554-69.475 32.185V-216q0 33.287-23.422 56.709-23.422 23.422-56.709 23.422H216Zm2.87-83.001h522.26v-522.26H218.87v108.652q42.13 22.63 65.597 63.772 23.468 41.141 23.468 88.706 0 49.01-23.468 90.168Q261-348.674 218.87-327.283v108.413ZM480-480Z">
                                                    </path>
                                                </g>
                                            </svg>
                                        </span>

                                        <span v-if="!sidebarCollapsed" class="hidden md:inline whitespace-nowrap">
                                            Install free extension</span>
                                    </button>
                                    <button v-else type="button" @click="openInternalRecorder()"
                                        class="rounded-md border-blue-gradient hover:border-blue-gradient-hover border text-sm font-semibold text-gray-100 shadow-sm  focus-visible:outline-none text-left flex items-center gap-x-3 overflow-hidden"
                                        :class="[sidebarCollapsed ? 'p-1 size-10 justify-center' : 'flex-block px-3 py-2 w-full text-left']"
                                        v-tippy="{ content: sidebarCollapsed ? 'Record my Screen' : null, placement: 'right' }">
                                        <VideoCameraIcon :class="[sidebarCollapsed ? 'size-4' : 'size-5', 'shrink-0']"
                                            aria-hidden="true" /> <span v-if="!sidebarCollapsed"
                                            class="whitespace-nowrap">Record my
                                            Screen</span>
                                    </button>
                                </li>
                                <li class="flex justify-center">
                                    <button type="button" @click="openRequestLink()"
                                        class="rounded-md border-blue-gradient hover:border-blue-gradient-hover border text-sm font-semibold text-gray-100 shadow-sm  focus-visible:outline-none text-left flex items-center gap-x-3 overflow-hidden"
                                        :class="[sidebarCollapsed ? 'p-1 size-10 justify-center' : 'flex-block px-3 py-2 w-full text-left']"
                                        v-tippy="{ content: sidebarCollapsed ? 'Request a recording' : null, placement: 'right' }">
                                        <LinkIcon :class="[sidebarCollapsed ? 'size-4' : 'size-5', 'shrink-0']"
                                            aria-hidden="true" />
                                        <span v-if="!sidebarCollapsed" class="whitespace-nowrap">Request a
                                            recording</span>
                                    </button>
                                </li>
                            </ul>
                        </li>

                        <li>
                            <div v-show="!sidebarCollapsed" class="text-xs/6 font-semibold text-gray-400 mb-2">Library
                            </div>
                            <ul role="list" class="-mx-2 space-y-1">
                                <li :class="[sidebarCollapsed ? 'flex justify-center items-center' : '']">
                                    <inertia-link :href="route('library.incoming')" :class="[is_route_incoming ? 'bg-white text-gray-800' : 'text-gray-400 hover:bg-gray-800 hover:text-white',
                                    sidebarCollapsed ? 'size-10 justify-center' : 'justify-between',
                                        'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold items-center ']"
                                        v-tippy="{ content: sidebarCollapsed ? 'Incoming' : null, placement: 'right' }">
                                        <InboxArrowDownIcon
                                            :class="[sidebarCollapsed ? 'size-4' : 'size-5', 'shrink-0']"
                                            aria-hidden="true" />
                                        <span v-if="!sidebarCollapsed" class="whitespace-nowrap flex-1">Incoming</span>

                                    </inertia-link>

                                </li>
                                <li :class="[sidebarCollapsed ? 'flex justify-center items-center' : '']">
                                    <inertia-link :href="route('library.team')" :class="[is_route_team ? 'bg-white text-gray-800' : 'text-gray-400 hover:bg-gray-800 hover:text-white',
                                    sidebarCollapsed ? 'size-10 justify-center' : 'justify-between',
                                        'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold items-center ']"
                                        v-tippy="{ content: sidebarCollapsed ? 'Team' : null, placement: 'right' }">
                                        <UserGroupIcon :class="[sidebarCollapsed ? 'size-4' : 'size-5', 'shrink-0']"
                                            aria-hidden="true" />
                                        <span v-if="!sidebarCollapsed" class="whitespace-nowrap flex-1">Team</span>
                                    </inertia-link>
                                </li>
                                <li :class="[sidebarCollapsed ? 'flex justify-center items-center' : '']">
                                    <inertia-link :href="route('library.personal')"
                                        :class="[is_route_personal ? 'bg-white text-gray-800' : 'text-gray-400 hover:bg-gray-800 hover:text-white',
                                        sidebarCollapsed ? 'size-10 justify-center' : ' justify-between', 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold items-center']"
                                        v-tippy="{ content: sidebarCollapsed ? 'Personal' : null, placement: 'right' }">
                                        <UserIcon :class="[sidebarCollapsed ? 'size-4' : 'size-5', 'shrink-0']"
                                            aria-hidden="true" />
                                        <span v-if="!sidebarCollapsed" class="whitespace-nowrap flex-1">Personal</span>
                                    </inertia-link>
                                </li>
                            </ul>


                            <div v-if="unified_personals_enabled" v-show="!sidebarCollapsed"
                                class="text-xs/6 font-semibold text-gray-400 mb-2 mt-5">Admin View
                            </div>
                            <ul v-if="unified_personals_enabled" role="list" class="-mx-2 space-y-1">
                                <li :class="[sidebarCollapsed ? 'flex justify-center items-center' : '']">
                                    <inertia-link :href="route('library.unified_personals')" :class="[is_route_admin_view ? 'bg-white text-gray-800' : 'text-gray-400 hover:bg-gray-800 hover:text-white',
                                    sidebarCollapsed ? 'size-10 justify-center' : 'justify-between',
                                        'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold items-center ']"
                                        v-tippy="{ content: sidebarCollapsed ? 'Unified Personals' : null, placement: 'right' }">
                                        <UsersIcon :class="[sidebarCollapsed ? 'size-4' : 'size-5', 'shrink-0']"
                                            aria-hidden="true" />
                                        <span v-if="!sidebarCollapsed" class="whitespace-nowrap flex-1">Unified
                                            Personals</span>

                                    </inertia-link>

                                </li>
                            </ul>
                        </li>

                        <li v-if="false">
                            <div class="text-xs/6 font-semibold text-gray-400">Your teams</div>
                            <ul role="list" class="-mx-2 mt-2 space-y-1">
                                <li v-for="team in teams" :key="team.name">
                                    <a :href="team.href"
                                        :class="[team.current ? 'bg-gray-800 text-white' : 'text-gray-400 hover:bg-gray-800 hover:text-white', 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold']">
                                        <span
                                            class="flex size-6 shrink-0 items-center justify-center rounded-lg border border-gray-700 bg-gray-800 text-[0.625rem] font-medium text-gray-400 group-hover:text-white">{{
                                                team.initial }}</span>
                                        <span class="truncate">{{ team.name }}</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li class="mt-auto flex flex-col gap-y-4"
                            :class="[sidebarCollapsed ? 'flex items-center' : '']">

                            <inertia-link v-if="false" type="button" :href="route('settings.helpdesk')"
                                class="rounded-md bg-transparent  text-sm font-normal text-gray-300 hover:text-gray-200 focus-visible:outline-none text-center flex justify-center items-center gap-x-3 hover:scale-105 transition-all duration-300 group"
                                :class="[sidebarCollapsed ? 'flex items-center size-10 justify-center hover:bg-gray-800' : '-ml-3 px-3 py-0']"
                                v-tippy="{ content: sidebarCollapsed ? 'Refer your friends' : null, placement: 'right' }">
                                <img src="/img/waving-hand.png" alt="wave"
                                    class="rotate-[20deg] size-5 group-hover:-rotate-[20deg] transition-all duration-200" />
                                <span v-if="!sidebarCollapsed" class="whitespace-nowrap">Refer your friends</span>
                            </inertia-link>

                            <div class="h-px bg-gray-700 -mx-2" :class="[sidebarCollapsed ? 'w-full' : '']"></div>

                            <inertia-link type="button"
                                v-if="$page.props.canManageSettings && !$page.props.has_integrations"
                                :href="route('settings.helpdesk')"
                                class="rounded-md bg-birdie-green  text-sm font-semibold text-birdie-dark shadow-sm hover:bg-birdie-green-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-birdie-green-dark text-left"
                                :class="[sidebarCollapsed ? 'flex items-center size-10 justify-center' : '-mx-2 px-3 py-2']"
                                v-tippy="{ content: sidebarCollapsed ? 'Connect Helpdesk' : null, placement: 'right' }">
                                <span v-if="!sidebarCollapsed" class="whitespace-nowrap">Connect Helpdesk</span>
                                <span v-else>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 -960 960 960"
                                        fill="currentColor">
                                        <path
                                            d="M380-120v-120L240-380v-220q0-33 23.5-56.5T320-680h40l-40 40v-200h80v160h160v-160h80v200l-40-40h40q33 0 56.5 23.5T720-600v220L580-240v120H380Z" />
                                    </svg>
                                </span>
                            </inertia-link>


                            <inertia-link :href="settingsLandingPage"
                                :class="[route().current('settings.*') || route().current('profile.show') || route().current('teams.*') || route().current('subscription.*') ? 'bg-white text-gray-800' : 'text-gray-400 hover:bg-gray-800 hover:text-white',
                                sidebarCollapsed ? 'items-center size-10 justify-center' : '', 'group -mx-2 flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold items-center']"
                                v-tippy="{ content: sidebarCollapsed ? 'Settings' : null, placement: 'right' }">
                                <Cog8ToothIcon class="size-5 shrink-0" aria-hidden="true" />
                                <span v-if="!sidebarCollapsed" class="whitespace-nowrap">Settings</span>
                            </inertia-link>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>

        <div v-if="!is_guest"
            :class="[sidebarCollapsed ? 'lg:pl-16' : 'lg:pl-72', 'flex flex-col flex-1 h-full transition-[padding] duration-300 ease-in-out']">
            <div
                class="sticky top-0 z-[70] flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
                <button type="button" class="-m-2.5 p-2.5 text-gray-700 lg:hidden" @click="sidebarOpen = true">
                    <span class="sr-only">Open sidebar</span>
                    <Bars3Icon class="size-6" aria-hidden="true" />
                </button>

                <!-- Separator -->
                <div class="h-6 w-px bg-gray-900/10 lg:hidden" aria-hidden="true" />

                <div class="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">


                    <div v-if="settings_page"
                        class="grid flex-1 grid-cols-1 w-full relative font-bold text-gray-900 h-full items-center justify-center">
                        Settings
                    </div>
                    <div v-else class="grid flex-1 grid-cols-1 w-full relative">
                        <searchbar :searchroute="route('library.search')" searchType="video">
                        </searchbar>
                    </div>



                    <div class="flex items-center gap-x-4">

                        <div v-if="$page.props.subscription_status && !$page.props.subscription_status.active_subscription"
                            class="hidden space-x-8 sm:-my-px sm:flex">

                            <div class="flex justify-center h-full items-center"
                                v-if="$page.props.subscription_status.free_trial || (!$page.props.subscription_status.free_trial && $page.props.canManageSettings)">

                                <a class="group inline-flex items-center border border-transparent leading-4 font-medium rounded-md text-birdie-blue bg-white focus:outline-none transition"
                                    :href="route('subscription.index')">

                                    <div v-if="$page.props.subscription_status.free_trial || $page.props.canManageSettings"
                                        class="flex items-center gap-x-2 px-2 py-1 bg-birdie-blue/10 border border-transparent rounded-full font-medium text-xs text-birdie-blue group-hover:bg-birdie-blue/70 group-hover:border-birdie-blue group-hover:text-white">

                                        <StarIcon class="size-3" />
                                        <span v-if="$page.props.subscription_status.free_trial">
                                            Trial: {{ $page.props.subscription_status.free_trial_days_left }} days
                                            left</span>
                                        <span v-else>
                                            Upgrade Plan
                                        </span>

                                    </div>
                                </a>
                            </div>

                        </div>


                        <Menu as="div" class="relative">
                            <MenuButton class="-m-1.5 flex items-center p-1.5">
                                <span class="sr-only">Get Help</span>
                                <QuestionMarkCircleIcon class="size-6 text-gray-400" aria-hidden="true" />
                                <span class="hidden lg:flex lg:items-center">
                                    <span class="ml-1 text-sm/6 font-semibold text-gray-400"
                                        aria-hidden="true">Help</span>
                                </span>
                            </MenuButton>
                            <transition enter-active-class="transition ease-out duration-100"
                                enter-from-class="transform opacity-0 scale-95"
                                enter-to-class="transform opacity-100 scale-100"
                                leave-active-class="transition ease-in duration-75"
                                leave-from-class="transform opacity-100 scale-100"
                                leave-to-class="transform opacity-0 scale-95">
                                <MenuItems
                                    class="absolute right-0 z-60 mt-2.5 w-40  origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">

                                    <MenuItem>
                                    <a href="#" @click.prevent="openChat"
                                        class="openChat flex items-center gap-x-2 px-3 py-1 text-sm/6 text-gray-900 hover:bg-gray-50">
                                        <ChatBubbleLeftIcon class="size-4" /> Chat
                                        with
                                        us
                                    </a>
                                    </MenuItem>

                                    <MenuItem>
                                    <a href="https://docs.birdie.so" target="_blank"
                                        class="flex items-center gap-x-2 px-3 py-1 text-sm/6 text-gray-900 hover:bg-gray-50">
                                        <BookOpenIcon class="size-4" /> Documentation
                                    </a>
                                    </MenuItem>

                                    <MenuItem>
                                    <a href="#" @click.prenvent.stop="bookAdemo"
                                        class="flex items-center gap-x-2 px-3 py-1 text-sm/6 text-gray-900 hover:bg-gray-50">
                                        <CalendarIcon class="size-4" /> Book a Demo
                                    </a>
                                    </MenuItem>

                                </MenuItems>
                            </transition>
                        </Menu>

                        <!-- Separator -->
                        <div class="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-900/10" aria-hidden="true" />

                        <!-- Profile dropdown -->
                        <Menu as="div" class="relative">
                            <MenuButton class="-m-1.5 flex items-center p-1.5">
                                <span class="sr-only">Open user menu</span>

                                <ProfileImage :user="$page.props.user" class="size-8 rounded-full bg-gray-50" />


                            </MenuButton>
                            <transition enter-active-class="transition ease-out duration-100"
                                enter-from-class="transform opacity-0 scale-95"
                                enter-to-class="transform opacity-100 scale-100"
                                leave-active-class="transition ease-in duration-75"
                                leave-from-class="transform opacity-100 scale-100"
                                leave-to-class="transform opacity-0 scale-95">
                                <MenuItems
                                    class="absolute right-0 z-60 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                                    <MenuItem v-if="$page.props.isz || $page.props.impersonating">
                                    <a v-if="$page.props.isz" href="/nova"
                                        class="flex items-center gap-x-2 px-3 py-1 text-sm/6 text-birdie-blue hover:bg-gray-50">
                                        <CogIcon class="size-4" /> Admin
                                    </a>
                                    <a v-else-if="$page.props.impersonating" href="#"
                                        @click.prevent="stopImpersonating()"
                                        class="flex items-center gap-x-2 px-3 py-1 text-sm/6 text-red-500 hover:bg-gray-50">
                                        <XMarkIcon class="size-4" /> Impersonate
                                    </a>
                                    </MenuItem>
                                    <MenuItem>
                                    <inertia-link :href="route('profile.show')"
                                        :class="[currentRoute.includes('profile.show') ? 'bg-gray-50 outline-none' : '', 'flex items-center gap-x-2 px-3 py-1 text-sm/6 text-gray-900 hover:bg-gray-50']">
                                        <UserIcon class="size-4" /> Profile
                                    </inertia-link>
                                    </MenuItem>
                                    <MenuItem>
                                    <a href="#" @click.prevent.stop="logout"
                                        class="flex items-center gap-x-2 px-3 py-1 text-sm/6 text-gray-900 hover:bg-gray-50">
                                        <ArrowRightStartOnRectangleIcon class="size-4" /> Sign Out
                                    </a>
                                    </MenuItem>
                                </MenuItems>
                            </transition>
                        </Menu>
                    </div>
                </div>
            </div>

            <div v-if="settings_page"
                class="hidden md:ml-6 md:flex md:space-x-8 sticky top-16 z-[50] bg-white pt-6 pb-3">
                <!-- Current: "border-indigo-500 text-gray-900", Default: "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" -->
                <inertia-link v-for="subnav in settingsSubnav" :key="subnav.name" :href="subnav.href"
                    :class="[subnav.current ? 'text-gray-900 border-gray-900' : 'text-gray-500 hover:border-gray-300 hover:text-gray-700 border-transparent ', 'inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium ']">{{
                        subnav.name }}</inertia-link>
            </div>

            <main class="pt-0 pb-0 flex flex-col flex-grow">
                <div class="px-4 sm:px-6 lg:px-8 flex flex-grow" id="app-layout-slot">
                    <slot></slot>
                </div>
            </main>
        </div>

        <div v-else class="flex flex-col flex-1 h-full ">

            <div
                class="sticky top-0 z-[70] flex h-16 shrink-0 items-center gap-x-4  bg-white px-4  sm:px-6 lg:px-8 mx-auto w-full  border-b border-gray-200 shadow-sm ">

                <div
                    class="mx-auto w-full max-w-7xl flex h-16 shrink-0 items-center gap-x-4 justify-between sm:gap-x-6">

                    <div class="flex h-16 shrink-0 items-center">
                        <inertia-link href="https://www.birdie.so">
                            <img class="h-8 w-auto" src="/img/birdie-logo.svg" alt="logo" />
                        </inertia-link>
                    </div>

                    <!-- <div class="flex flex-1 gap-x-4 self-stretch lg:gap-x-6"> -->

                    <!-- <div class="grid flex-grow grid-cols-1 w-full relative">

                    </div> -->

                    <div class="flex flex-shrink-0 items-center gap-x-4 text-sm">

                        <a href="https://app.birdie.so/hello" title="Login"
                            class="rounded-md border-transparent text-birdie-dark hover:bg-gray-100 border text-sm font-normal shadow-sm focus-visible:outline-none flex items-center flex-block px-3 py-2 text-nowrap">
                            Login
                        </a>

                        <!-- <button type="button" @click="openRequestLink()"
                            class="rounded-md border-blue-gradient hover:border-blue-gradient-hover border text-sm font-semibold text-gray-100 shadow-sm  focus-visible:outline-none text-left flex items-center gap-x-3 overflow-hidden"
                            :class="[sidebarCollapsed ? 'p-1 size-10 justify-center' : 'flex-block px-3 py-2 w-full text-left']"
                            v-tippy="{ content: sidebarCollapsed ? 'Request a recording' : null, placement: 'right' }">
                            <LinkIcon :class="[sidebarCollapsed ? 'size-4' : 'size-5', 'shrink-0']"
                                aria-hidden="true" />
                            <span v-if="!sidebarCollapsed" class="whitespace-nowrap">Request a
                                recording</span>
                        </button> -->

                        <a href="https://app.birdie.so/hello" title="Get Birdie Free"
                            class="rounded-md border-birdie-blue text-birdie-blue hover:bg-gray-100 border text-sm font-semibold shadow-sm focus-visible:outline-none flex items-center flex-block px-3 py-2 text-left text-nowrap">
                            Get Birdie Free
                        </a>

                    </div>

                </div>

            </div>
            <!-- </div> -->

            <div v-if="route().current('settings.*') || route().current('profile.*') || route().current('teams.*') || route().current('subscription.*')"
                class="hidden md:ml-6 md:flex md:space-x-8 sticky top-16 z-[50] bg-white pt-6 pb-3">
                <!-- Current: "border-indigo-500 text-gray-900", Default: "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" -->
                <inertia-link v-for="subnav in settingsSubnav" :key="subnav.name" :href="subnav.href"
                    :class="[subnav.current ? 'text-gray-900 border-gray-900' : 'text-gray-500 hover:border-gray-300 hover:text-gray-700 border-transparent ', 'inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium ']">{{
                        subnav.name }}</inertia-link>
            </div>

            <main class="pt-0 pb-0 flex flex-col flex-grow">
                <div class="px-4 sm:px-6 lg:px-8 flex flex-grow">
                    <slot></slot>
                </div>
            </main>
        </div>

        <modal-request-link v-if="!is_guest" ref="modalRequestLink"></modal-request-link>

        <modal-upgrade-plan v-if="!is_guest" ref="upgradeModal" :message_admin="upgrade_modal_message_admin"
            :message_agent="upgrade_modal_message_agent" :issue="upgrade_modal_issue"
            :key="'upgrade_modal_route_' + route().current()"></modal-upgrade-plan>

    </div>
</template>

<script>
import JetApplicationMark from '@/Jetstream/ApplicationMark'
import JetBanner from '@/Jetstream/Banner'
import JetDropdown from '@/Jetstream/Dropdown'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import JetNavLink from '@/Jetstream/NavLink'
import JetResponsiveNavLink from '@/Jetstream/ResponsiveNavLink'

import ModalUpgradePlan from '@/Components/Modals/UpgradePlan'
import { PlusIcon, StarIcon, XMarkIcon, UserIcon, UserGroupIcon, Cog8ToothIcon, VideoCameraIcon, LinkIcon, InboxArrowDownIcon, ArrowRightStartOnRectangleIcon, CogIcon, ChatBubbleLeftIcon, BookOpenIcon, CalendarIcon, ChevronLeftIcon, UsersIcon } from "@heroicons/vue/20/solid";
import { UserPlusIcon } from "@heroicons/vue/24/outline";

import Searchbar from '@/Components/UI/Searchbar'

import ModalRequestLink from '@/Components/Modals/RequestLink'
import ProfileImage from '@/Components/UI/ProfileImage'

import { initBirdie } from "@birdie-so/snippet";



import {
    Dialog,
    DialogPanel,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    TransitionChild,
    TransitionRoot,
} from '@headlessui/vue'
import {
    // InboxArrowDownIcon,
    //UserGroupIcon,
    //UserIcon,
    // LinkIcon,
    // Cog6ToothIcon,
    // VideoCameraIcon,
    QuestionMarkCircleIcon,
    Bars3Icon

} from '@heroicons/vue/24/outline'




export default {
    components: {
        JetApplicationMark,
        JetBanner,
        JetDropdown,
        JetDropdownLink,
        JetNavLink,
        JetResponsiveNavLink,
        ModalUpgradePlan,
        StarIcon,
        PlusIcon,
        Searchbar,
        ModalRequestLink,
        Bars3Icon,
        ProfileImage,

        Dialog,
        DialogPanel,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        TransitionChild,
        TransitionRoot,
        ArrowRightStartOnRectangleIcon,
        CogIcon,
        ChatBubbleLeftIcon,
        BookOpenIcon,
        CalendarIcon,
        ChevronLeftIcon,
        UsersIcon,

        InboxArrowDownIcon,
        UserGroupIcon,
        UserIcon,
        LinkIcon,
        Cog8ToothIcon,
        VideoCameraIcon,
        QuestionMarkCircleIcon,
        XMarkIcon,
        UserPlusIcon,

    },

    data() {
        return {
            showingNavigationDropdown: false,
            has_onboarded: false,
            is_guest: this.$page.props.is_guest,
            upgrade_modal_message_admin: "",
            upgrade_modal_message_agent: "",
            upgrade_modal_issue: "",
            check_session_interval: "",
            sidebarOpen: !this.$page.props.is_guest,
            first_require: false,
            extension_loaded: window.extension_loaded,
            extension_not_loaded_for_sure: false,
            extension_listener: false,
            is_chrome: false,
            currentRoute: route().current(),
            ask_to_expand_sidebar: false,
            ask_to_collapse_sidebar: false,
            settingsLandingPage: this.$page.props.canManageSettings ? route('settings.index') : route('profile.show'),
            folders: this.$page.props.folders ? this.$page.props.folders : [],
            team_metadata: null,
            unified_personals_enabled: false
            // sidebarCollapsed: route().current() == "library.video"
        }
    },

    created: function () {

        const ua = navigator.userAgent
        const vendor = navigator.vendor
        this.is_chrome = ua.includes("Chrome") && vendor === "Google Inc."

        //console.log(this.$i18n.locale)
        this.EventBus.on("showUpgrade", (data) => {
            if (data[1]) {
                this.upgrade_modal_issue = data[1]
            }
            const type = data[0]
            if (type == "feature") {
                this.upgrade_modal_message_admin = "Your current subscription does not allow you to access this feature, you need to upgrade your plan."
                this.upgrade_modal_message_agent = "Your current subscription does not allow you to access this feature, you need to ask an administrator to upgrade your plan."
            } else {
                this.upgrade_modal_message_admin = "Your current subscription does not allow you to access more videos, you need to upgrade your plan."
                this.upgrade_modal_message_agent = "Your current subscription does not allow you to access more videos, you need to ask an administrator to upgrade your plan."
            }
            this.showUpgradeModal()
        });

        this.EventBus.on('settingChanged', (data) => {
            if (data.key == "unified_personals_enabled") {
                if (this.$page.props.is_admin) {
                    this.unified_personals_enabled = data.value
                }
            }
        })


        if (this.$page.props.usermeta) {
            if (this.$page.props.usermeta.first_require) {
                this.first_require = this.$page.props.usermeta.first_require == "yes"
            }
        }

        if (window.extension_loaded) {
            this.extension_loaded = true
            this.extension_not_loaded_for_sure = false
        }

        this.$watch(
            () => this.$page.url,
            () => {
                this.currentRoute = route().current()
            }
        )

        //console.log("route is",this.route().current())

        // if (!this.is_guest) {
        //     this.has_onboarded = this.$page.props.usermeta.onboarding ? this.$page.props.usermeta.onboarding == "yes" : false
        //     this.check_session_interval = setInterval(function(){
        //         this.checkSession()
        //     }.bind(this), 30000)
        // }

        //console.log(this.$t("Click here to watch").toLowerCase())

        // this.$inertia.on('navigate', (event) => {
        //     console.log("navigate", event)
        //     document.dispatchEvent(new CustomEvent('WORKSPACE_LOADED', {
        //         detail: {}
        //     }));
        // });

        if (this.$page.props.user && !this.$page.props.is_helpdesk) {
            this.initSnippet()
        }

        if (this.$page.props.user?.current_team?.metadata) {
            this.team_metadata = JSON.parse(this.$page.props.user?.current_team?.metadata)
            if (this.$page.props.is_admin) {
                this.unified_personals_enabled = this.team_metadata.unified_personals_enabled ?? false
            }
        }


    },



    mounted() {

        this.extension_loaded = window.extension_loaded;
        if (!this.extension_loaded) {
            this.extension_listener = true
            document.addEventListener('EXTENSION_RESPONSE', this.extension_loaded_listener);
            setTimeout(() => {
                this.extension_not_loaded_for_sure = !this.extension_loaded
            }, 500)
            document.dispatchEvent(new CustomEvent('GET_EXTENSION_STATE', {
                detail: {}
            }));
        }



    },
    beforeUnmount() {
        this.EventBus.off('showUpgrade');
        this.EventBus.off('changeSetting');
        // this.$inertia.off('navigate');
        // document.removeEventListener('EXTENSION_LOADED', this.handleExtensionReady);
        clearInterval(this.check_session_interval)
        if (this.extension_listener) {
            document.removeEventListener('EXTENSION_RESPONSE', this.extension_loaded_listener);
        }
    },
    methods: {
        initSnippet() {
            initBirdie({
                clientId: "e4bf56a2",
                metadata: {
                    user: {
                        id: this.$page.props.user.id,
                        email: this.$page.props.user.email,
                    },
                    team: {
                        id: this.$page.props.user.current_team.id,
                        name: this.$page.props.user.current_team.name,
                    },
                },
                onReady(birdie) {
                    //console.log("Birdie is ready", birdie)
                    birdie.on("start", (data) => {
                        console.log("Recording started", data)
                    });

                    birdie.on("stop", (data) => {
                        console.log("Recording stopped", data)
                    });

                    // birdie.metadata = {
                    //     user: {
                    //         id: this.$page.props.user.id,
                    //         email: this.$page.props.user.email,
                    //     },
                    // }
                },
            });
        },
        expandSidebar() {
            this.ask_to_expand_sidebar = true
            this.ask_to_collapse_sidebar = false
        },
        collapseSidebar() {
            this.ask_to_collapse_sidebar = true
            this.ask_to_expand_sidebar = false
        },
        bookAdemo() {
            // console.log("bookAdemo", typeof Calendly)
            if (typeof Calendly !== "object") {
                return
            }
            Calendly.initPopupWidget({ url: 'https://calendly.com/birdie_max/20min' })
        },
        logout() {
            this.$inertia.post(route('logout'), {}, {
                onSuccess: () => {
                    window.location.href = route('login');
                }
            });
        },
        extension_loaded_listener: function (event) {
            // console.log("extension_loaded_listener fired", event)
            this.extension_loaded = true
            window.extension_loaded = true
            this.extension_not_loaded_for_sure = false
        },

        openRequestLink() {
            this.$refs.modalRequestLink.open()
            this.set_onboarding_done()
        },

        openInternalRecorder() {
            // console.log("openInternalRecorder", this.extension_loaded, this.is_chrome)

            if (this.extension_loaded) {
                document.dispatchEvent(new CustomEvent('START_RECORDING_ASKED', {
                    detail: {}
                }));
                return
            } else if (this.is_chrome) {
                // console.log("B")
                // console.log("SHOULD INSTALL EXTENSION")
                window.location.href = "https://chromewebstore.google.com/detail/birdie/glkfmfjeafnooojgeobbhdjhdejocoap"
                return
            }


            this.EventBus.emit('onboarding_step_validation', 'first_record')
            window.initRecorder(this.$page.props.user.current_team.slugname,
                this.$page.props.user.id,
                this.$page.props.app_url)
            return
        },
        set_onboarding_done() {
            if (this.first_require) {
                return
            }
            let url = this.$page.props.api_url + '/v1/user/set_meta';
            var params = {
                meta: "first_require",
                value: "yes"
            };
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    if (response.data) {
                        this.first_require = true
                        this.EventBus.emit('onboarding_step_validation', 'first_require');
                    }
                })
                .catch(e => {
                    console.error(e);
                });
        },

        // handleExtensionReady(event) {
        //     // console.log("EXTENSION_LOADED", event)
        //     this.EventBus.emit('EXTENSION_LOADED', event)
        // },
        async stopImpersonating() {
            await axios.delete('/impersonate')
            window.location.href = `/nova/resources/users/${this.$page.props.user.id}`
        },

        checkSession() {
            let url = this.$page.props.api_url + '/v1/checksession';
            axios.get(url)
                .then(response => {
                    //console.log(response.data)
                })
                .catch(e => {
                    clearInterval(this.check_session_interval)
                    this.logout()
                });
        },
        switchToTeam(team) {
            this.$inertia.put(route('current-team.update'), {
                'team_id': team.id
            }, {
                preserveState: false
            })
        },

        // logout() {
        //     this.$inertia.post(route('logout'));
        // },

        showUpgradeModal() {
            //console.log("showUpgradeModal")
            this.$refs.upgradeModal.open()
        },

        openChat() {
            // if (typeof window.openChat === "function") {
            //     window.openChat()
            // }
            if (typeof Intercom === "function") {
                Intercom('show')
            }

        },

        openLauncher() {
            if (typeof window.zest !== undefined) {
                window.zest.widget.open()
            }
        },


    },
    computed: {
        sidebarCollapsed() {
            return this.ask_to_collapse_sidebar || (this.currentRoute.includes('library.video') && !this.ask_to_expand_sidebar)
        },
        settings_page() {
            return this.currentRoute.includes('settings.') || this.currentRoute.includes('profile.') || this.currentRoute.includes('teams.') || this.currentRoute.includes('subscription.')
        },
        is_route_incoming() {
            if (!this.currentRoute.startsWith('library.')) {
                return false
            }
            return !this.currentRoute.includes('library.team') &&
                !this.currentRoute.includes('library.search') &&
                !this.currentRoute.includes('library.personal') &&
                !this.currentRoute.includes('library.unified_personals') &&
                !this.is_sent_video &&
                !this.is_mine
        },
        is_route_admin_view() {
            if (!this.currentRoute.startsWith('library.')) {
                return false
            }
            return this.currentRoute.includes('library.unified_personals')
        },
        is_route_sent() {
            if (!this.currentRoute.startsWith('library.')) {
                return false
            }
            return this.currentRoute.includes('library.team') || this.is_sent_video
        },
        is_route_team() {
            if (!this.currentRoute.startsWith('library.')) {
                return false
            }
            return this.currentRoute.includes('library.team') || (this.is_sent_video && !this.is_mine)
        },
        is_route_personal() {
            if (!this.currentRoute.startsWith('library.')) {
                return false
            }
            return this.currentRoute.includes('library.personal') ||
                (this.is_sent_video && this.is_mine && !this.is_others)
        },



        is_sent_video() {
            if (this.$page.props.video) {
                return this.$page.props.video.sent
            } else if (this.$page.props.the_video) {
                return this.$page.props.the_video.sent
            }
            return false
        },
        is_mine() {
            if (this.$page.props.video) {
                return this.$page.props.video.mine
            } else if (this.$page.props.the_video) {
                return this.$page.props.the_video.mine
            }
            return false
        },
        is_others() {
            if (this.$page.props.video && this.$page.props.video.user_id != this.$page.props.user.id) {
                return this.$page.props.video.mine
            } else if (this.$page.props.the_video && this.$page.props.the_video.user_id != this.$page.props.user.id) {
                return this.$page.props.the_video.mine
            }
            return false
        },
        settingsSubnav() {
            let subnav = []
            if (this.$page.props.canManageSettings) {
                subnav.push({
                    name: "Team",
                    href: route('teams.show', this.$page.props.user.current_team),
                    current: this.currentRoute.includes('teams.show')
                })
            }
            subnav.push({
                name: "Helpdesk",
                href: route('settings.helpdesk'),
                current: this.currentRoute.includes('settings.helpdesk')
            })
            subnav.push({
                name: "Incoming Recordings",
                href: route('settings.incoming'),
                current: this.currentRoute.includes('settings.incoming') || this.currentRoute.includes('settings.index')
            })
            if (this.$page.props.canManageSettings) {
                subnav.push({
                    name: "Admin & Security",
                    href: route('settings.security'),
                    current: this.currentRoute.includes('settings.security')
                })
                subnav.push({
                    name: "Plans & Billing",
                    href: route('subscription.index'),
                    current: this.currentRoute.includes('subscription.index')
                })
            }
            subnav.push({
                name: "Profile",
                href: route('profile.show'),
                current: this.currentRoute.includes('profile.show')
            })

            return subnav

        }
    },
    watch: {
        currentRoute(newVal, oldVal) {
            if (newVal != oldVal && newVal.includes('library.video') && this.ask_to_expand_sidebar) {
                this.ask_to_expand_sidebar = false
            }
        }
    }
}
</script>
